import { RoutineRecentRunsRail } from '@/features/workflows/components/RoutineRecentRunsRail';
import { useRoutineForProject } from '@/features/workflows/hooks';
import { useRecentRunsRail } from '@/features/workflows/hooks/useRecentRunsRail';
import { ProjectRunRecentRunsRail as ProjectRunRecentRunsRailView } from '@heidi/agents';

const renderRecentRunsRail = (workflowId: string) => (
  <RoutineRecentRunsRail workflowId={workflowId} />
);

/**
 * Binds the routine "Recent runs" slot beside a Work chat to the routine backing
 * the chat, its rail state ({@link useRecentRunsRail}) and the workflows root's
 * recent-runs card.
 */
export const ProjectRunRecentRunsRail = ({
  projectId,
}: {
  projectId: string | undefined;
}) => {
  const { workflow } = useRoutineForProject(projectId);
  const { hasRuns, isOpen } = useRecentRunsRail(workflow?.workflow_id ?? '');
  return (
    <ProjectRunRecentRunsRailView
      workflowId={workflow ? workflow.workflow_id : undefined}
      hasRuns={hasRuns}
      isOpen={isOpen}
      renderRail={renderRecentRunsRail}
    />
  );
};
